/**
 * Composable helpers for CMS content.
 *
 * These are thin wrappers around useCmsStore that handle fetching
 * automatically — components just call the composable and read data.
 */
import { computed, onMounted } from 'vue'
import { useCmsStore } from '@/store/cms'

function ensureFetched(store) {
  onMounted(() => store.fetchAll())
}

export function useSubscriptionPlans() {
  const store = useCmsStore()
  ensureFetched(store)
  return {
    plans:     computed(() => store.plans),
    isLoaded:  computed(() => store.isLoaded),
  }
}

export function usePopularRegions() {
  const store = useCmsStore()
  ensureFetched(store)
  return {
    regions:  computed(() => store.regions),
    isLoaded: computed(() => store.isLoaded),
  }
}

export function useRewardActivities() {
  const store = useCmsStore()
  ensureFetched(store)
  return {
    activities: computed(() => store.activities),
    isLoaded:   computed(() => store.isLoaded),
  }
}

export function useFooter() {
  const store = useCmsStore()
  ensureFetched(store)
  return {
    footerSections: computed(() => store.footerSections),
    siteConfig:     computed(() => store.siteConfig),
    isLoaded:       computed(() => store.isLoaded),
  }
}

export function useAnnouncementBanner() {
  const store = useCmsStore()
  ensureFetched(store)
  return {
    banner:   computed(() => store.banner),
    isLoaded: computed(() => store.isLoaded),
  }
}
